<template>
  <div class="boxbgcolor abcpay-api-configure">
    <!--左侧树形展示所有停车场-->
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right configure-right">
      <div class="content-right-left">
        <el-form ref="addOrEditForm" label-width="200px" :rules="rules" :model="payConfigure">
          <el-form-item label="商户号" prop="partnerId">
            <el-input v-model="payConfigure.partnerId" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>
          <el-form-item label="入账商户号" prop="merchantId">
            <el-input v-model="payConfigure.merchantId" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>
          <el-form-item label="证书密码" prop="password">
            <el-input v-model="payConfigure.password" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>
          <el-form-item prop="openFlag">
            <el-checkbox v-model="payConfigure.openFlag" label="是否启用" name></el-checkbox>
          </el-form-item>
        </el-form>
        <div class="submit">
          <el-button type="primary" size="medium" @click="addOrEdit">提交</el-button>
        </div>
      </div>
      <div class="content-right-right">
        <div class="content-right-right-inner">
          <div class="upload">
            <el-upload
              class="uploadTxt"
              list-type="text"
              action="/api/parking/abcPay/upload"
              multiple
              :limit="2"
              :headers="headers"
              :on-error="uploadError"
              :on-success="uploadSuccess"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </div>
          <div class="upload-tip"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { abcConfigureOne, abcConfigureAddOrEdit } from "@/api/url";

import AreaTree from "@/page/commons/areaTree";

import Cookies from "js-cookie";
export default {
  data() {
    return {
      treeData: {
        parkingId: "",
      },
      fileList: [],
      payConfigure: {
        id: "",
        partnerId: "",
        merchantId: "",
        password: "",
        openFlag: false,
      },
      headers: {
        Authorization: Cookies.get("Authorization"), //从cookie里获取token，并赋值  Authorization ，而不是token
      },
      rules: {
        configureTxt: [
          { required: true, message: "请上传验证文件", trigger: "blur" },
        ],
        partnerId: [{ required: true, message: "商户号", trigger: "blur" }],
        merchantId: [
          { required: true, message: "入账商户号", trigger: "blur" },
        ],
        password: [{ required: true, message: "证书密码", trigger: "blur" }],
      },
    };
  },
  methods: {
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.resetForm();
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.payConfigureOne();
      } else {
        this.payConfigure.id = "";
        this.payConfigure.partnerId = "";
        this.payConfigure.merchantId = "";
        this.payConfigure.password = "";
        this.payConfigure.openFlag = false;
        // this.$message({
        //     message: '请选择车场！',
        //     type: 'warning'
        // });
      }
      // if(node.level==2){
      // 	this.treeData.parkingId=data.parent.data.id;
      // 	this.treeData.areaId=node.id;
      // }
    },
    payConfigureOne() {
      this.$postRequest(abcConfigureOne(), {
        parkingId: this.treeData.parkingId,
      }).then((data) => {
        if (data.data) {
          this.treeData.parkingId = data.data.parkingId;
          this.payConfigure.id = data.data.id;
          this.payConfigure.partnerId = data.data.partnerId;
          this.payConfigure.merchantId = data.data.merchantId;
          this.payConfigure.password = data.data.password;
          this.payConfigure.openFlag = data.data.openFlag == "y" ? true : false;
        } else {
          // this.treeData.parkingId='';
          this.payConfigure.id = "";
          this.payConfigure.partnerId = "";
          this.payConfigure.merchantId = "";
          this.payConfigure.password = "";
          this.payConfigure.openFlag = false;
        }
      });
      // console.log(this.payConfigure.openflag)
    },
    addOrEdit() {
      let _this = this;
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
        return;
      }
      this.$refs.addOrEditForm.validate((valid) => {
        if (valid) {
          this.$postRequest(abcConfigureAddOrEdit(), {
            id: this.payConfigure.id,
            parkingId: this.treeData.parkingId,
            partnerId: this.payConfigure.partnerId,
            merchantId: this.payConfigure.merchantId,
            password: this.payConfigure.password,
            openFlag: this.payConfigure.openFlag ? "y" : "n",
          }).then((data) => {
            //提交后的操作
            if (data.status != 200) return _this.$layer.msg(data.message);
            _this.$notify({
              type: "success",
              title: "成功",
              message: "新增或修改配置成功!",
            });
          });
        } else {
        }
      });
    },
    uploadError() {
      this.$notify({
        type: "error",
        title: "上传失败",
        message: "请检查文件类型,重新上传!",
      });
    },
    uploadSuccess() {
      this.$notify({
        type: "success",
        title: "成功",
        message: "文件上传成功!",
      });
    },
    isParkingIdEmpty() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
      }
    },
    resetForm() {
      this.$refs["addOrEditForm"].resetFields();
    },
  },
  computed: {},
  components: {
    AreaTree,
  },

  mounted: function () {},
};
</script>

<style scoped>
.boxbgcolor {
}
.submit {
  text-align: center;
}
/* .uploadTxt{
        border:1px solid #ccc;
         border-radius:5px;
       height:45px;
       line-height:45px;
       padding-left:5px;
    } */
.configure-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
}
.content-right-right {
  width: 40%;
  height: 100%;
  margin: 0 3%;
}
.content-right-left {
  width: 60%;
  height: 100%;
  margin-right: 20px;
}
.content-right-right .upload {
  border: 2px dotted #ddd;
  border-radius: 10px;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-right-right-inner {
  height: 60%;
}
.upload-tip {
  color: red;
  margin-top: 10px;
  text-align: center;
}
</style>
<style>
.abcpay-api-configure .content-right .el-input__inner {
  border-radius: 5px;
  height: 45px;
  line-height: 45px;
}
.abcpay-api-configure .el-form-item {
  margin-bottom: 20px;
}
.abcpay-api-configure .el-form-item__label {
  height: 45px;
  line-height: 45px;
  color: #333 !important;
  font-weight: bold;
}
.abcpay-api-configure .submit .el-button {
  width: 200px;
  height: 50px;
}
.abcpay-api-configure .el-checkbox__label {
  color: #333 !important;
  font-weight: bold;
}
.abcpay-api-configure .el-upload__tip {
  height: 30px;
  line-height: 30px;
}
.abcpay-api-configure .el-upload__tip {
  color: red !important;
}
.abcpay-api-configure .el-upload,
.abcpay-api-configure .el-upload-list {
  float: none !important;
  display: block;
}
</style>